import React, { Component } from "react";
import { Element, scroller } from "react-scroll";
import MessageItem from "./MessageItem";
import Firebase from "../../../firebasehelper";
import { getStringfromSeconds } from "../../../functions";
import MessageInput from "../../AdminSupport/LiveChat/MessageInput";
var timer;

class MessageList extends Component {
  state = {
    showInput: false,
    messages: [],
    name: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      brand_typing: false,
    };
  }

  componentDidMount() {
    let { ticket, brand } = this.props;
    const { id: brand_id, name: brand_name } = brand;
    const { id: ticket_id, type, time } = ticket;
    let time_str = getStringfromSeconds(time);

    Firebase.getSupportChat(brand_id, ticket_id, (res) => {
      let chats = Object.values(res);
      chats.unshift({
        message: `${brand_name} has requested support with <b>${type}</b> on ${time_str}.`,
        type: "brand",
        username: "Bot",
      });
      this.setState({ messages: chats });
    });
    Firebase.getBrandTyping(brand_id, ticket_id, (typing) => {
      this.setState({ brand_typing: typing });
    });
    this.scrollToBottom();
  }
  componentWillReceiveProps(nextProps) {
    let { ticket, brand } = nextProps;
    const { id: brand_id, name: brand_name } = brand;
    const { id: ticket_id, type, time } = ticket;
    let time_str = getStringfromSeconds(time);
    Firebase.getSupportChat(brand_id, ticket_id, (res) => {
      let chats = Object.values(res);
      chats.unshift({
        message: `${brand_name} has requested support with <b>${type}</b> on ${time_str}.`,
        type: "brand",
        username: "Bot",
      });
      this.setState({ messages: chats });
    });
    Firebase.getBrandTyping(brand_id, ticket_id, (typing) => {
      this.setState({ brand_typing: typing });
    });
    this.scrollToBottom();
  }
  scrollToBottom(delay = 0) {
    scroller.scrollTo("bottom", {
      duration: 200,
      delay: 0,
      smooth: "easeInOutQuart",
      containerId: "containerElement",
    });
  }

  setMessages() {
    const { icon } = this.props;
    const { messages } = this.state;
    setTimeout(() => this.scrollToBottom(), 100);
    return messages.map((message, i) => {
      return (
        <MessageItem message={message} key={i} icon={icon} loaded={true} />
      );
    });
  }

  setMessageInState(message) {
    const messages = this.state.messages.slice();
    messages.push(message);
    this.setState({ messages });
  }

  addMessage = (message) => {
    const { brand, ticket } = this.props;
    const { id: ticket_id } = ticket;
    const { id: brand_id } = brand;

    message.time = new Date().getTime().toString();

    this.setMessageInState(message);
    Firebase.addSupportMessage(brand_id, ticket_id, message, (res) => {
      Firebase.setBrandUnReadMessage(brand_id, ticket_id, {
        latest: message.message,
        time: message.time,
        ticket: ticket,
      });
    });
    setTimeout(() => this.scrollToBottom(), 100);
  };
  onType = () => {
    const { brand, ticket } = this.props;
    const { id: ticket_id } = ticket;
    const { id: brand_id } = brand;
    Firebase.setAdminTypeValue(brand_id, ticket_id, true);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      Firebase.setAdminTypeValue(brand_id, ticket_id, false);
    }, 1000);
  };
  render() {
    const { brand_typing } = this.state;
    const { username } = this.props;
    return (
      <div className="message-list-wrapper-container">
        <div className="message-list-wrapper">
          <Element className="message-items-container" id="containerElement">
            {this.setMessages()}
            {brand_typing && (
              <MessageItem message={{ type: "brand" }} loaded={false} />
            )}
            <Element name="bottom"></Element>
          </Element>
          <div
            component="div"
            className="message-input-container"
            ref={(el) => {
              this.messagesEnd = el;
            }}
          >
            <MessageInput
              addMessage={this.addMessage}
              onType={this.onType}
              username={username}
              type="admin"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MessageList;



// WEBPACK FOOTER //
// ./src/screens/SuperSupport/LiveChat/MessageList.js